/**
 * @fileoverview gRPC-Web generated client stub for witbooking.loyalty.tag.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.loyalty = {};
proto.witbooking.loyalty.tag = {};
proto.witbooking.loyalty.tag.v1 = require('./loyalty_tag_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.ListTagsRequest,
 *   !proto.witbooking.loyalty.tag.v1.ListTagsResponse>}
 */
const methodDescriptor_LoyaltyTagAPI_ListTags = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/ListTags',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.ListTagsRequest,
  proto.witbooking.loyalty.tag.v1.ListTagsResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.ListTagsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.ListTagsRequest,
 *   !proto.witbooking.loyalty.tag.v1.ListTagsResponse>}
 */
const methodInfo_LoyaltyTagAPI_ListTags = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.tag.v1.ListTagsResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.ListTagsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.tag.v1.ListTagsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.tag.v1.ListTagsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.listTags =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/ListTags',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_ListTags,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.tag.v1.ListTagsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.listTags =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/ListTags',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_ListTags);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.GetTagRequest,
 *   !proto.witbooking.loyalty.tag.v1.GetTagResponse>}
 */
const methodDescriptor_LoyaltyTagAPI_GetTag = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/GetTag',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.GetTagRequest,
  proto.witbooking.loyalty.tag.v1.GetTagResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.GetTagResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.GetTagRequest,
 *   !proto.witbooking.loyalty.tag.v1.GetTagResponse>}
 */
const methodInfo_LoyaltyTagAPI_GetTag = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.tag.v1.GetTagResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.GetTagResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.tag.v1.GetTagResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.tag.v1.GetTagResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.getTag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/GetTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_GetTag,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.tag.v1.GetTagResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.getTag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/GetTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_GetTag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest,
 *   !proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse>}
 */
const methodDescriptor_LoyaltyTagAPI_CreateMultipleTagsExcel = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/CreateMultipleTagsExcel',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest,
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest,
 *   !proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse>}
 */
const methodInfo_LoyaltyTagAPI_CreateMultipleTagsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.createMultipleTagsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/CreateMultipleTagsExcel',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_CreateMultipleTagsExcel,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.tag.v1.CreateMultipleTagsExcelResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.createMultipleTagsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/CreateMultipleTagsExcel',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_CreateMultipleTagsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest,
 *   !proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse>}
 */
const methodDescriptor_LoyaltyTagAPI_DownloadTagsTemplateExcel = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/DownloadTagsTemplateExcel',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest,
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest,
 *   !proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse>}
 */
const methodInfo_LoyaltyTagAPI_DownloadTagsTemplateExcel = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.downloadTagsTemplateExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/DownloadTagsTemplateExcel',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_DownloadTagsTemplateExcel,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.tag.v1.DownloadTagsTemplateExcelResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.downloadTagsTemplateExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/DownloadTagsTemplateExcel',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_DownloadTagsTemplateExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.CreateTagRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagAPI_CreateTag = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/CreateTag',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.CreateTagRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.CreateTagRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagAPI_CreateTag = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.createTag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/CreateTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_CreateTag,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.createTag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/CreateTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_CreateTag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.UpdateTagRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagAPI_UpdateTag = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/UpdateTag',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.UpdateTagRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.UpdateTagRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagAPI_UpdateTag = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.updateTag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/UpdateTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_UpdateTag,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.updateTag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/UpdateTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_UpdateTag);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.DeleteTagRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagAPI_DeleteTag = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/DeleteTag',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.DeleteTagRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.DeleteTagRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagAPI_DeleteTag = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIClient.prototype.deleteTag =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/DeleteTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_DeleteTag,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagAPIPromiseClient.prototype.deleteTag =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagAPI/DeleteTag',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagAPI_DeleteTag);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest,
 *   !proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse>}
 */
const methodDescriptor_LoyaltyTagSectionAPI_ListTagSections = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/ListTagSections',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest,
  proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest,
 *   !proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse>}
 */
const methodInfo_LoyaltyTagSectionAPI_ListTagSections = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient.prototype.listTagSections =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/ListTagSections',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_ListTagSections,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.ListTagSectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.tag.v1.ListTagSectionsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient.prototype.listTagSections =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/ListTagSections',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_ListTagSections);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.GetTagSectionRequest,
 *   !proto.witbooking.loyalty.tag.v1.GetTagSectionResponse>}
 */
const methodDescriptor_LoyaltyTagSectionAPI_GetTagSection = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/GetTagSection',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.GetTagSectionRequest,
  proto.witbooking.loyalty.tag.v1.GetTagSectionResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.GetTagSectionRequest,
 *   !proto.witbooking.loyalty.tag.v1.GetTagSectionResponse>}
 */
const methodInfo_LoyaltyTagSectionAPI_GetTagSection = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.tag.v1.GetTagSectionResponse,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.tag.v1.GetTagSectionResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.tag.v1.GetTagSectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient.prototype.getTagSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/GetTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_GetTagSection,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.GetTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.tag.v1.GetTagSectionResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient.prototype.getTagSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/GetTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_GetTagSection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagSectionAPI_CreateTagSection = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/CreateTagSection',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagSectionAPI_CreateTagSection = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient.prototype.createTagSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/CreateTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_CreateTagSection,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.CreateTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient.prototype.createTagSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/CreateTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_CreateTagSection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagSectionAPI_UpdateTagSection = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/UpdateTagSection',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagSectionAPI_UpdateTagSection = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient.prototype.updateTagSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/UpdateTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_UpdateTagSection,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.UpdateTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient.prototype.updateTagSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/UpdateTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_UpdateTagSection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagSectionAPI_DeleteTagSection = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/DeleteTagSection',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagSectionAPI_DeleteTagSection = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient.prototype.deleteTagSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/DeleteTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_DeleteTagSection,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.DeleteTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient.prototype.deleteTagSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/DeleteTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_DeleteTagSection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LoyaltyTagSectionAPI_ReorderTagSection = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/ReorderTagSection',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_LoyaltyTagSectionAPI_ReorderTagSection = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIClient.prototype.reorderTagSection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/ReorderTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_ReorderTagSection,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.tag.v1.ReorderTagSectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.tag.v1.LoyaltyTagSectionAPIPromiseClient.prototype.reorderTagSection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.tag.v1.LoyaltyTagSectionAPI/ReorderTagSection',
      request,
      metadata || {},
      methodDescriptor_LoyaltyTagSectionAPI_ReorderTagSection);
};


module.exports = proto.witbooking.loyalty.tag.v1;

